import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppTheme from "Theme/AppTheme";
import AcxLogoLoader from "components/UI/Loaders/AcxLogoLoader";
import AuthPage from "./AuthPage";
import Login from "./Login";
import {
    SamlLoginProvider,
    readCachedSamlLoginOption,
    writeCachedSamlLoginOption,
} from "./samlLoginOptionCache";

export type { SamlLoginProvider };

function LoginUser() {
    const [samlLoginProvider, setSamlLoginProvider] = useState<
        SamlLoginProvider | null | undefined
    >(readCachedSamlLoginOption);

    useEffect(() => {
        async function check() {
            try {
                const response = await fetch(
                    "/api/Authenticate/CheckForSamlLoginOption",
                );
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data: SamlLoginProvider = await response.json();
                const provider =
                    data.samlLoginProviderExists === true ? data : null;
                setSamlLoginProvider(provider);
                writeCachedSamlLoginOption(provider);
            } catch {
                // Fall back to the username/password form rather than
                // blocking login on a failed SAML lookup.
                setSamlLoginProvider((current) => current ?? null);
            }
        }
        check();
    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage shouldShowLinks shouldShowLogo={false}>
                    {samlLoginProvider === undefined ? (
                        <AcxLogoLoader height={55} width={55} isSpinning />
                    ) : (
                        <Login samlLoginProvider={samlLoginProvider} />
                    )}
                </AuthPage>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default LoginUser;
